const cfg =
  typeof window !== 'undefined'
    ? window.CONFIG || {}
    : {};

export const AppConfig = Object.freeze({
  env: cfg.REACT_APP_ENV || 'dev',

  samsBaseUrl: cfg.REACT_APP_SAMS_BASE_URL,
  fastApiBaseUrl: cfg.REACT_APP_FAST_API_BASE_URL,

  keycloakUrl: cfg.REACT_APP_KEYCLOACK_URL,
  keycloakLogin:
    cfg.REACT_APP_KEYCLOAK_LOGIN === true,

  errorLoggerUrl: cfg.REACT_APP_ERROR_LOGGER,
  kibanaUrl: cfg.REACT_APP_KIBANA_URL,

  enableEncryption:
    cfg.REACT_APP_ENABLE_ENCRYPTION === true,

  uiHost: cfg.REACT_APP_UI_HOST,
});